import { toDate as o } from "./toDate.js";
function a(e) {
  const t = o(e);
  return t.setMinutes(0, 0, 0), t;
}
export {
  a as default,
  a as startOfHour
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/startOfHour.js
// module id = 1446
// module chunks = 67